<template>
    <div id="app">
        <router-view name="header"></router-view>
        <main>
            <fade-transition origin="center" mode="out-in" :duration="250">
                <router-view/>
            </fade-transition>
        </main>
        <router-view name="footer"></router-view>
        <cookie-law  
            buttonText="Accept" 
            buttonClass="Cookie__button btn btn-secondary"
            position="bottom" 
            transitionName="fade"
        >

            <div slot="message">
                This website uses cookies to ensure you get the best experience on our website. 
                For more information visit our <router-link to="/dataprivacy">Data Privacy</router-link> site.
            </div>
        </cookie-law>
    </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
import CookieLaw from "vue-cookie-law";

export default {
  components: {
    FadeTransition,
    CookieLaw
  }
};
</script>

<style>
.Cookie {
  background-color: whitesmoke;
  font-size: 0.8rem;
}
.Cookie.Cookie--base .Cookie__button {
  border-radius: unset;
  background: #f4f5f7;
  color: black;
}
.Cookie.Cookie--base .Cookie__button:hover,
.Cookie.Cookie--base .Cookie__button:active {
  background-color: #f4f5f7;
  color: black;
}
.Cookie a {
  color: rgb(66, 204, 201);
}
</style>
